import {InjectionToken} from '@angular/core';

export const LANGUAGE_OVERRIDE = new InjectionToken<string | undefined>('LANGUAGE_OVERRIDE');
